import store from "../store";

async function requireAuth(to, _from, next) {
  if (store.state.auth.isAuthorizedToUseDashboard) {
    next();
  } else {
    const postData = new FormData();

    postData.append("fsg_code", to.query.code);
    postData.append("teamwork_id", to.query.tid);
    postData.append("alleson_id", to.query.aid);
    postData.append("email", to.query.email);
    postData.append("name", to.query.company);
    postData.append("terms", to.query.terms);
    postData.append("price_group", to.query.pricegroup);
    postData.append("carriedt", to.query.carriedt);
    postData.append("carrier_num", to.query.carriednum);
    postData.append("web_user_id", to.query.webuserid);

    await store.dispatch("dealer/getFullDealerDataOrCreateItInDashboard", {
      token: to.query.token,
      accountid: to.query.code,
      postData: postData,
      web_user_id: to.query.webuserid,
      rep_token: to.query.rep_token,
    });

    next();
  }
}

export { requireAuth };
